// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import { Spin } from 'antd';
import * as S from './styled';

const Loading = () => {
  return (
    <S.Wrapper>
      <Spin size="large" />
    </S.Wrapper>
  );
};

export default Loading;
